export const environment = {
    tenantID: '',
    pageName: 'MVP CMS',
    appFlavor: 'mvp',
    production: false,
    appEnv: 'dev',
    googleMapsKey: 'AIzaSyCQtW5k7XRFK4akkOW9iGmQUwi4LhQm5oA',
    apiConfig: {
        projectEndpoint: 'https://api-airline.itxi.aero',
        apiKey: '19876r44cd-12c2-4e99-b502-2bb6936a3e02',
    },
    firebase: {
        apiKey: 'AIzaSyCQtW5k7XRFK4akkOW9iGmQUwi4LhQm5oA',
        authDomain: 'airline-app-mvp.firebaseapp.com',
        databaseURL: 'https://airline-app-mvp.firebaseio.com',
        projectId: 'airline-app-mvp',
        storageBucket: 'airline-app-mvp.appspot.com',
        messagingSenderId: '845186263188',
        appId: '1:845186263188:web:b13bef630c30f455466c81',
        measurementId: 'G-XHK8G8VQH9',
    },
    googleAnalyticsTrackId: '',
    rolesWithLoginAccess: [
        {
            role: 'admin',
            route: 'dashboard/content/users',
            node: 'users',
        },
        {
            role: 'power_user',
            route: 'dashboard/content/airports',
            node: 'airports',
        },
        {
            role: 'viewer',
            route: 'dashboard/content/airports',
            node: 'airports',
        },
    ],
    sessionTokenCheckInterval: 300000,
    getAllFlightsListInterval: 300000,
    sessionTokenExtension: true,
    defaultRoute: 'dashboard/content/users',
    enableRandomBackground: false,
    isGoogleAnalyticEnabled: false,
    airportCoordinates: {
        latitude: 31.80531216145772,
        longitude: -106.3824336070223,
        ISO3166_1_Alpha_2: 'US',
    },
    videoCategories: [],
    userTableLanguages: [{ key: 'en', label: 'LANGUAGES.ENGLISH_ONLY' }],
    userTablesRole: [
        { key: 'admin', label: 'ROLES.ADMIN' },
        { key: 'power_user', label: 'ROLES.POWER_USER' },
        {
            key: 'viewer',
            label: 'ROLES.VIEWER',
        },
    ],
    formLanguages: [
        { key: 'en', title: 'LANGUAGES.ENGLISH', label: 'FORMS.EN_LANG' },
        { key: 'es', title: 'LANGUAGES.ESPANOL', label: 'FORMS.ES_LANG' },
    ],
    microsoftSSOClientId: '',
    googleSSOClientId:
        '845186263188-uj7a03r5tuq6falr2ukmcmpbk6emfuud.apps.googleusercontent.com',
    signInOptions: ['password', 'google'],
    appCategories: [],
    payment_method: [],
    payment_status: [],
    orientationArray: [],
    containerType: [],
    contentType: [],
    contentItems: [],
    equipmentType: [],
    departureTime: [],
    sectors: [],
    cartItems: [],
};
